/* LALTERNATIVA — pagina collezione.
   Il menu a tendina "Ordina" in HTML e largo quanto la sua opzione piu lunga.
   Petal & Pup mostra solo il valore scelto con la freccia subito accanto,
   quindi qui misuriamo il testo selezionato e stringiamo il select.
   La larghezza va scritta con priorita important perche il CSS usa
   width:auto !important per neutralizzare lo stile del tema. */
(function () {
  var canvas;

  function fit(select) {
    var cs = window.getComputedStyle(select);
    var option = select.options[select.selectedIndex];
    if (!option) return;
    var text = option.text || '';
    canvas = canvas || document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    ctx.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
    var spacing = parseFloat(cs.letterSpacing) || 0;
    var width = ctx.measureText(text).width + spacing * text.length + parseFloat(cs.paddingRight || 0) + 2;
    select.style.setProperty('width', Math.ceil(width) + 'px', 'important');
  }

  function init() {
    var selects = document.querySelectorAll('.product-grid__header .collection-sortby select');
    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      if (select.dataset.lasFit) continue;
      select.dataset.lasFit = '1';
      fit(select);
      select.addEventListener('change', function () {
        fit(this);
      });
    }
  }

  function watch() {
    var scope = document.querySelector('#ProductGridContainer');
    if (!scope || !window.MutationObserver) return;
    var pending;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(init, 60);
    }).observe(scope, { childList: true, subtree: true });
  }

  function start() {
    init();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      var selects = document.querySelectorAll('.product-grid__header .collection-sortby select');
      for (var i = 0; i < selects.length; i++) fit(selects[i]);
    });
  }
})();
